var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":`${_vm.dataFile.url}`,"target":"_blank"}},[_vm._v("Скачать "+_vm._s(_vm.formatBytes(_vm.dataFile.size)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }